<main-app-header></main-app-header>
<div class="thankyou-bg privacy-policy-bg">
  <div class="logo">
    <!-- <div>
      <a [routerLink]="['/']"><img src="./assets/images/logo.png" /></a>
      <span style="margin-top:-20px" class="trademark2">™</span>
    </div> -->
  </div>
  <!-- <div class="backlink pointer"><a (click)="backClicked()"><i class="fas fa-chevron-left"></i> Home</a></div> -->
  <div class="thankyou-box box-shadow privacy-policy-box">

    <h5>About QUANTUM RESISTANT ENCRYPTION—QRE</h5>

    <p>
      The FBI, government agencies, private cybersecurity organizations, and technical publications all agree—we need to prepare for quantum computing today.  Nations and private entities are all researching and developing quantum computers that will be orders of magnitude faster than present classical computing.
    </p>

    <p>
      That means even the best encryption in use today may be broken, and no communications is safe from hackers or malicious nation-states.
    </p>

    <p>
      With Titanium Comms QRE, protection against quantum computers is available today.  QRE follows a National Institute of Standards and Technology (NIST) protocol and is always on to protect you in the background. It is encryption that cannot be broken even with quantum computing, which is why NIST had the foresight to set the standard.
    </p>

    <p>
      Titanium Comms is the only fully integrated platform built from the ground up with privacy and security as fundamental design goals. Titanium Comms fills the gap left by others Zoom, Skype, Signal, Telegram, What’s App, and AWS’  Wikr, Teams, and others whose after-thought security or origins with government agencies around the globe leave customers in doubt as to the safety of their platforms.
    </p>

    <p>
      We did not stop with QRE.  All our servers are located in the U.S.A. No communications content is stored on servers—everything is device dependent once content is delivered.   All communications—text, audio, video—are encrypted. We are the first and only company in the industry to provide this level of encryption.
    </p>

    <p>
      Titanium Comms is a subscription service, so we validate users and prevent access by bad actors and bots. Unlike the alternatives, we do not sell nor share user data. The only data we keep are your subscriber information and nothing else.
    </p>

    <p>
      Titanium Comms works on desktops (MAC, Windows, Linux), mobile devices (iOS, Android). Features include one-to-one or group voice or video calls, video conferences, texts with disappearing messages set independently by each sender for their messages. QRE also means secure file sharing between subscribed users.
    </p>

  </div>
</div>
